module.exports = __webpack_public_path__ + "img/chess_checkersyellow.f5722797.png";